import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  useFeature,
  useFeatureEnabled,
  useProfile
} from "@/providers/ProfileProvider";
import { getFirstAvailableRoute } from "@/lib/navigation";
import { useAssistantChatFeature } from "@/hooks/useAssistantChatFeature";

export default function SmartRedirect() {
  const navigate = useNavigate();
  const { userRoles } = useProfile();

  // Call all hooks at the top level (Rules of Hooks)
  const featureDashboard = useFeature("dashboard");
  // useFeature prepends "feature.", and the default matches the
  // declaration: assistant chat is on unless a tenant turns it off.
  const featureAssistantChat = useFeatureEnabled("assistant-chat", true);
  const featureLiveChat = useFeature("live-chat");
  const featureCalls = useFeature("calls");
  const featureDocuments = useFeature("documents");
  const featureDbTables = useFeature("db-tables");
  const featureServiceAssistant = useFeatureEnabled("service-assistant", true);
  const featureOntologyLookup = useFeatureEnabled("ontology-lookup", true);
  const featureUsageStatistics = useFeatureEnabled("usage-statistics", true);
  const featureServiceKpis = useFeatureEnabled("service-kpis", false);
  const featureTicketing = useFeature("ticketing");
  const featureCustomerChat = useFeature("customer-chat");

  const { assistantChatEnabled } = useAssistantChatFeature();

  useEffect(() => {
    const firstAvailableRoute = getFirstAvailableRoute({
      userRoles: {
        isAdmin: userRoles.isAdmin,
        isLytraStaff: userRoles.isLytraStaff,
        isAgent: userRoles.isAgent,
      },
      features: {
        dashboard: featureDashboard,
        assistantChat: featureAssistantChat,
        liveChat: featureLiveChat,
        calls: featureCalls,
        documents: featureDocuments,
        assistantChatEnabled,
        dbTables: featureDbTables,
        serviceAssistant: featureServiceAssistant,
        ontologyLookup: featureOntologyLookup,
        usageStatistics: featureUsageStatistics,
        serviceKpis: featureServiceKpis,
        ticketing: featureTicketing,
        customerChat: featureCustomerChat,
      },
    });

    void navigate(firstAvailableRoute, { replace: true });
  }, [
    navigate,
    userRoles.isAdmin,
    userRoles.isLytraStaff,
    userRoles.isAgent,
    featureDashboard,
    featureAssistantChat,
    featureLiveChat,
    featureCalls,
    featureDocuments,
    assistantChatEnabled,
    featureDbTables,
    featureServiceAssistant,
    featureOntologyLookup,
    featureUsageStatistics,
    featureServiceKpis,
    featureTicketing,
    featureCustomerChat,
  ]);

  return null; // This component doesn't render anything
}
